import { memo } from 'react';
import { Card, AutoDeleteMessagesIcon, ContentDrawer, tools } from '@halo/ui-chat-react';
import {
  Box,
  Flex,
  RadioGroup,
  type RadioGroupValueChangeDetails,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const AutoDeleteMessagesCard = memo(function AutoDeleteMessagesCard({
  value,
  onSelect,
}: {
  value?: number;
  onSelect?: (value: number) => void;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const handleOpenChange = useCallback(
    (open: boolean) => {
      setOpen?.(open);
    },
    [setOpen]
  );

  const handleSelect = useCallback(
    ({ value }: RadioGroupValueChangeDetails) => {
      if (value === null) return;
      onSelect?.(Number(value));
      setOpen?.(false);
    },
    [onSelect, setOpen]
  );

  return (
    <Card>
      <Flex alignItems="center" gap="2.5" justifyContent="space-between">
        <Flex gap="2.5" alignItems="center">
          <Box fontSize="4xl">
            <AutoDeleteMessagesIcon />
          </Box>
          <Stack gap="1">
            <Text fontSize="sm" fontWeight="medium">
              {t('chatSettings.autoDeleteMessages')}
            </Text>
          </Stack>
        </Flex>
        <ContentDrawer
          open={open}
          onOpenChange={handleOpenChange}
          title={t('chatSettings.autoDeleteMessages')}
          trigger={
            <Box fontSize="lg" mr="2.5" cursor="pointer">
              <Box color="brand" fontSize="sm" fontWeight="medium">
                {value !== undefined && tools.expireTimeOptions.findByValue(value)?.label}
              </Box>
            </Box>
          }
        >
          <Box bg="bg" rounded="xl" mb="2">
            <RadioGroup.Root value={value?.toString()} onValueChange={handleSelect}>
              <Stack gap="0">
                {tools.expireTimeOptions.map((item) => (
                  <Box key={item.value} position="relative">
                    <RadioGroup.Item value={String(item.value)} px="2" py="3.5" cursor="pointer">
                      <RadioGroup.ItemHiddenInput />
                      <RadioGroup.ItemIndicator />
                      <RadioGroup.ItemText fontWeight="semibold" fontSize="sm">
                        {item.label}
                      </RadioGroup.ItemText>
                    </RadioGroup.Item>
                  </Box>
                ))}
              </Stack>
            </RadioGroup.Root>
          </Box>
        </ContentDrawer>
      </Flex>
    </Card>
  );
});
